import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)


import Vuex from 'vuex';
import store from '@/state/'
import Trend from "vuetrend"
import VueApexCharts from 'vue-apexcharts'

require('dotenv').config()

Vue.use(Trend)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if(store.getters.AccessTokenExpired) {
      next({ name: 'login', params: { next: to.name, params: to.params, query: Object.assign({}, to.query) } })
      return false;
    } else {
      if(store.getters.auth) {
        next();
      } else {
        next({
          name: 'login',
          params: { next: to.name, params: to.params, query: Object.assign({}, to.query) } })
      }
    }
  } else {
    next();
  }
})


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
